<div class="material-datatables">
  <table id="companiestables" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">
    <thead>
      <tr>
        <th>{{ dataTable.headerRow[0] }}</th>
        <th>CV Code</th>
        <th>{{ dataTable.headerRow[1] }}</th>
        <th>{{ dataTable.headerRow[2] }}</th>
        <th>{{ dataTable.headerRow[8] }}</th>
        <th>{{ dataTable.headerRow[3] }}</th>
        <th>{{ dataTable.headerRow[4] }}</th>
        <th>{{ dataTable.headerRow[5] }}</th>

        <th class="disabled-sorting text-right">{{ dataTable.headerRow[6] }}</th>
      </tr>
  </thead>
  <tbody>
      <tr *ngFor="let row of dataTable.dataRows">
          <td>{{row[0]}}</td>
          <td>{{row[6]}}</td>
          <td>{{row[1]}}</td>
          <td>{{row[2]}}</td>
          <td>{{row[7]}}</td>
          <td>{{row[3]}}</td>
          <td>{{row[4]}}</td>
          <td>
            <button class="btn {{row[5] == '1' ? 'btn-success' : 'btn-danger'}} btn-sm emitir" id="delete-{{row[0]}}">
              <span class="material-icons">power_settings_new</span> &nbsp; <span>{{row[5] == '1' ? 'Active' : 'Inactive'}}</span>
            </button>
          </td>

          <td class="text-right">
            <a  [routerLink]="['/pages/company', row[0]]" class="btn btn-link btn-info btn-just-icon"><i class="material-icons">remove_red_eye</i></a>

            <!--<a (click)="deleteFolderfirst(row[0])" class="btn btn-link btn-danger btn-just-icon"><i class="material-icons">close</i></a>-->
          </td>
      </tr>
  </tbody>
    </table>
</div>
